const STORAGE_KEY_PREFIX = "wwg_support_previously_viewed_";
const MAX_ITEMS = 10;

function load(namespace) {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY_PREFIX + namespace);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    }
  } catch {
    // corrupted storage — reset
  }
  return [];
}

function save(namespace, items) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY_PREFIX + namespace,
      JSON.stringify(items.slice(0, MAX_ITEMS))
    );
  } catch {
    // storage quota exceeded
  }
}

export function recordView(namespace, item) {
  const trimmed = {
    id: item.id || item.sku || item.productId,
    name: item.name || item.title || "",
    sku: item.sku || item.productId || "",
    url: item.url || "",
    viewedAt: Date.now(),
  };

  const existing = load(namespace);
  const filtered = existing.filter((e) => e.id !== trimmed.id);
  filtered.unshift(trimmed);
  save(namespace, filtered);
}

export function getPreviouslyViewed(namespace) {
  return load(namespace);
}
